let csvw_url = 'https://www.csvw.com';
export default {
  // kv
  workspace: {
    videourl: csvw_url + "/u/cms/www/202105/171520345d1O.mp4"
  },
  // 车型素材
  workspace2: {
    neishi: [
      require("../../assets/octavia-pro/imgs/neishi/1.jpg"),
      require("../../assets/octavia-pro/imgs/neishi/2.jpg"),
      require("../../assets/octavia-pro/imgs/neishi/3.jpg"),
      require("../../assets/octavia-pro/imgs/neishi/4.jpg"),
      require("../../assets/octavia-pro/imgs/neishi/5.jpg"),
      require("../../assets/octavia-pro/imgs/neishi/6.jpg"),
      require("../../assets/octavia-pro/imgs/neishi/7.jpg"),
      require("../../assets/octavia-pro/imgs/neishi/8.jpg"),
      require("../../assets/octavia-pro/imgs/neishi/9.jpg")
    ],
    waiguan: [
      require("../../assets/octavia-pro/imgs/waiguan/1.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/2.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/3.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/4.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/5.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/6.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/7.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/8.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/9.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/10.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/11.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/12.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/13.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/14.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/15.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/16.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/17.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/18.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/19.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/20.jpg"),
      require("../../assets/octavia-pro/imgs/waiguan/21.jpg"),
    ],
    qita: [
      require("../../assets/octavia-pro/imgs/qita/1.jpg"),
      require("../../assets/octavia-pro/imgs/qita/2.jpg"),
      require("../../assets/octavia-pro/imgs/qita/3.jpg"),
      require("../../assets/octavia-pro/imgs/qita/4.jpg"),
      require("../../assets/octavia-pro/imgs/qita/5.jpg"),
      require("../../assets/octavia-pro/imgs/qita/6.jpg"),
      require("../../assets/octavia-pro/imgs/qita/7.jpg"),
      require("../../assets/octavia-pro/imgs/qita/8.jpg"),
      require("../../assets/octavia-pro/imgs/qita/9.jpg"),
      require("../../assets/octavia-pro/imgs/qita/10.jpg"),
      require("../../assets/octavia-pro/imgs/qita/11.jpg"),
      require("../../assets/octavia-pro/imgs/qita/12.jpg"),
      require("../../assets/octavia-pro/imgs/qita/13.jpg"),
      require("../../assets/octavia-pro/imgs/qita/14.jpg"),
      require("../../assets/octavia-pro/imgs/qita/15.jpg"),
      require("../../assets/octavia-pro/imgs/qita/16.jpg"),
      require("../../assets/octavia-pro/imgs/qita/17.jpg"),
      require("../../assets/octavia-pro/imgs/qita/18.jpg"),
      require("../../assets/octavia-pro/imgs/qita/19.jpg"),
    ],
    shipin: [
      require("../../assets/octavia-pro/imgs/shipin/1.jpg"),
      require("../../assets/octavia-pro/imgs/shipin/1.jpg"),
      require("../../assets/octavia-pro/imgs/shipin/1.jpg"),
    ],
    videourl: [
      csvw_url + "/u/cms/www/202105/171520345d1O.mp4",
      csvw_url + "/u/cms/www/202105/171520345d1O.mp4",
      csvw_url + "/u/cms/www/202105/171520345d1O.mp4"
    ],
  },
  // 新闻稿
  workspace3: {
    list: [{
        title: '12.49万-15.79万元',
        title1: '斯柯达全新明锐PRO革新上市',
        subtitle: '5月17日，上汽大众斯柯达全新明锐PRO革新上市，发布性能版、豪华版、尊贵版、旗舰版四款车型，售价区间为12.49万-15.79万元。本次活动通过线上开箱的形式，不仅有资深汽车媒体人、全新明锐PRO准车主精彩助阵，还带来惊喜盲盒现场开启。全新明锐PRO将凭借其全面升级的产品实力，带领消费者进入数字驾乘新时代，重新为A+级轿车市场树立新风尚。',
        imgurl: require("../../assets/octavia-pro/imgs/xinwen/news1@2x.png"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/xinwen/news1-m@2x.png"),
        url: 'https://www.csvw.com/csvw-website/news/skoda-brand-news.html?newsid=3037'
      },
      {
        title: '请查收',
        title1: '全新明锐PRO动态体验报告',
        subtitle: '随着对全新明锐PRO的动态测评陆续展开，相关驾控体验报告相继“出炉”，赢得了众多专业汽车媒体的肯定。全新明锐PRO全系标配1.4TSI高功率发动机、7速双离合变速箱、前后独立悬架，在动态测评中杰出的动力表现给大家留下了深刻的印象。',
        imgurl: require("../../assets/octavia-pro/imgs/xinwen/news2@2x.png"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/xinwen/news2-m@2x.png"),
        url: 'https://www.csvw.com/csvw-website/news/skoda-brand-news.html?newsid=2992'
      },
      {
        title: '探访上汽大众宁波工厂',
        title1: '解密全新明锐PRO诞生记',
        subtitle: '随着全新明锐PRO首秀发布、专业媒体测评陆续展开，新车关注度日益高涨。全新明锐PRO是基于全新MQB EVO数字智能架构打造的A+级三厢掀背轿车，无论是制造工艺或是驾驶体验，有着明显德系车的风格特征，并带来数字化、电气化的全面提升。',
        imgurl: require("../../assets/octavia-pro/imgs/xinwen/news3@2x.png"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/xinwen/news3-m@2x.png"),
        url: 'https://www.csvw.com/csvw-website/news/skoda-brand-news.html?newsid=2991'
      }
    ]
  },
  // 大咖点评
  workspace4: {
    list: [{
        title: require("../../assets/octavia-pro/imgs/logo/1.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/1.png"),
        subtitle: '全新明锐PRO全新设计的立体垂瀑式格栅造型年轻犀利，发动机盖上的立体棱线营造出三维立体雕塑感。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/1.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/1.jpg"),
        url: 'http://auto.news18a.com/news/storys_154191.html'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/2.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/2.png"),
        subtitle: '全新明锐PRO配备了无线Car Play和Car Life以及手机无线充电功能，车机互联与充电的双无线设计在日常使用过程中非常方便。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/2.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/2.jpg"),
        url: 'http://auto.news18a.com/news/storys_153357.html'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/3.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/3.png"),
        subtitle: '全新明锐PRO的T型中控台布局整齐有序，悬浮式中控屏和“911同款”的电子挡杆大大提升了科技感。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/3.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/3.jpg"),
        url: 'http://auto.ifeng.com/c/84vCDp3dm3a'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/4.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/4.png"),
        subtitle: '全新明锐PRO内饰材质上选择众多软性包覆材质，在中控区和门板处均采用软性皮质材料及同色缝线，中控区更是使用带有碳纤维纹理的Carbon材质包覆，内饰质感大幅提升。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/4.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/4.jpg"),
        url: 'http://auto.ifeng.com/c/84qinBwijfg'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/5.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/5.png"),
        subtitle: '全新明锐PRO配备了同级罕有的电子排挡，不仅操作便捷，也更加节省空间。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/5.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/5.jpg"),
        url: 'https://www.youcheyihou.com/news/1090735'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/6.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/6.png"),
        subtitle: '全新明锐PRO采用了大掀背设计，不仅后备厢容积表现出色，其后排乘坐空间并没有丝毫“缩水”。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/6.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/6.jpg"),
        url: 'http://www.dazhongkanche.com/undefined/20210430/66417.html'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/7.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/7.png"),
        subtitle: '全新明锐PRO实现了集按键、手势、触控、语音在内的多元操控形式，可以带来更为便捷的交互体验。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/7.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/7.jpg"),
        url: 'https://c.m.163.com/news/a/G6FTRSE00008856V.html'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/8.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/8.png"),
        subtitle: '全新明锐PRO全系车型均装备了RS运动套件，类似于大众的R-line版本，但风格更硬朗，具体体现在前杠运动风格造型、尾部扩散器、镀铬排气装饰。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/8.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/8.jpg"),
        url: 'https://new.qq.com/omn/20210427/20210427A0BMSN00.html'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/9.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/9.png"),
        subtitle: '全新明锐PRO搭载斯柯达智慧车联系统的车型，配合斯柯达超级APP，拥有智能语音、智慧导航、智享娱乐、智趣出行、智联控车5大核心功能。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/9.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/9.jpg"),
        url: 'https://www.sohu.com/a/458499221_400718?referid=0008'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/10.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/10.png"),
        subtitle: '全新明锐PRO采用全新MQB EVO数字智能架构，全车15个超声波、毫米波雷达，以及5个摄像头，打造全新升级的德系数字科技体验。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/10.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/10.jpg"),
        url: 'https://www.toutiao.com/i6958784925118022158'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/11.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/11.png"),
        subtitle: '全新明锐PRO全系标配1.4TSI高功率发动机、最大扭矩250N.m，兼具澎湃的动力体验与优秀的燃油经济性。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/11.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/11.jpg"),
        url: 'https://mp.weixin.qq.com/s/IMuJflTOdkruoTJhGFXXzg'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/12.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/12.png"),
        subtitle: '全新明锐PRO在欧洲版车型基础上做加法，轴距加长44mm，车内空间更为宽绰，加之标志性的大掀背设计，实用性满分。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/12.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/12.jpg"),
        url: 'https://mp.weixin.qq.com/s/HEfMl1kkiKj6RQIijCg4vA'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/13.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/13.png"),
        subtitle: '全新明锐PRO更宽更扁平化的直瀑式中网搭配粗壮的镀铬饰条装饰，双L型设计的LED大灯组也不再采用分体式造型，整体感更强。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/13.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/13.jpg"),
        url: 'https://mp.weixin.qq.com/s/xUmbIllejKXxiRd4bfCtdA'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/14.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/14.png"),
        subtitle: '全新明锐PRO使用的外观套件，其实和欧洲市场明锐RS车型的外观套件是同款，相较老款车型在视觉冲击感上的营造更加到位。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/14.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/14.jpg"),
        url: 'https://www.qctt.cn/news/997121'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/15.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/15.png"),
        subtitle: '全新明锐PRO车内整体设计思路也与上一代大相径庭，全液晶仪表、大尺寸悬浮式中控屏、电子挡杆等部件凸显了全新明锐PRO的时尚和科技感，同时也兼顾了不错的运动氛围。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/15.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/15.jpg"),
        url: 'http://news.yiche.com/hao/wenzhang/46317710'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/16.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/16.png"),
        subtitle: '全新明锐PRO采用的是大众集团最新的MQB EVO数字智能架构，融合了大众集团最新的车身结构、电子系统架构等先进技术，能够搭载远超上代车型的功能和配置。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/16.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/16.jpg"),
        url: 'https://auto.ifeng.com/c/86BYSFqOZdG'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/17.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/17.png"),
        subtitle: '全新明锐PRO凭借着宽适的空间表现、优雅的大掀背以及稳定的机械素质，迅速在市场上站稳脚跟，一度成为斯柯达在国内的“门面担当”。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/17.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/17.jpg"),
        url: 'https://chejiahao.autohome.com.cn/info/8578285'
      },
      {
        title: require("../../assets/octavia-pro/imgs/logo/18.png"),
        titleMobile: require("../../assets/octavia-pro/imgs/logo/18.png"),
        subtitle: '全新明锐PRO全系标配全新升级的后独立悬挂，该悬挂采用四连杆结构，可分解横向和纵向受力，带来更好的操控体验。',
        imgurl: require("../../assets/octavia-pro/imgs/daka/18.jpg"),
        imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/18.jpg"),
        url: 'http://news.yiche.com/hao/wenzhang/46322233'
      },
      // {
      //   title: require("../../assets/octavia-pro/imgs/logo/19.png"),
      //   titleMobile: require("../../assets/octavia-pro/imgs/logo/19.png"),
      //   subtitle: '全新明锐PRO后排座椅支持4/6比例放倒，放倒后后备箱容积达1482L，储物空间表现优异。',
      //   imgurl: require("../../assets/octavia-pro/imgs/daka/19.jpg"),
      //   imgurlMobile: require("../../assets/octavia-pro/imgsMobile/daka/19.jpg"),
      //   // url: 'http://www.yidianzixun.com/article/0UJSrbm6'
      // },
    ]
  },
  // 媒体试驾
  workspace5: {
    // 移动端
    shipin: [
      require("../../assets/octavia-pro/imgs/shijia/1.jpg"),
      require("../../assets/octavia-pro/imgs/shijia/2.jpg"),
      require("../../assets/octavia-pro/imgs/shijia/3.jpg"),
      require("../../assets/octavia-pro/imgs/shijia/4.jpg"),
      require("../../assets/octavia-pro/imgs/shijia/5.jpg"),
      require("../../assets/octavia-pro/imgs/shijia/6.jpg"),
      require("../../assets/octavia-pro/imgs/shijia/7.jpg"),
      require("../../assets/octavia-pro/imgs/shijia/8.jpg"),
      require("../../assets/octavia-pro/imgs/shijia/9.jpg"),
    ],
    // PC端
    shipinPC: [
      [
        require("../../assets/octavia-pro/imgs/shijia/1.jpg"),
        require("../../assets/octavia-pro/imgs/shijia/2.jpg"),
        require("../../assets/octavia-pro/imgs/shijia/3.jpg"),
      ],
      [
        require("../../assets/octavia-pro/imgs/shijia/4.jpg"),
        require("../../assets/octavia-pro/imgs/shijia/5.jpg"),
        require("../../assets/octavia-pro/imgs/shijia/6.jpg"),
      ],
      [
        require("../../assets/octavia-pro/imgs/shijia/7.jpg"),
        require("../../assets/octavia-pro/imgs/shijia/8.jpg"),
        require("../../assets/octavia-pro/imgs/shijia/9.jpg"),
      ]
    ],
    // 封面
    fengurl: [
      require("../../assets/octavia-pro/imgs/shijia/1.jpg"),
      require("../../assets/octavia-pro/imgs/shijia/2.jpg"),
      require("../../assets/octavia-pro/imgs/shijia/3.jpg"),
      require("../../assets/octavia-pro/imgs/shijia/4.jpg"),
      require("../../assets/octavia-pro/imgs/shijia/5.jpg"),
      require("../../assets/octavia-pro/imgs/shijia/6.jpg"),
      require("../../assets/octavia-pro/imgs/shijia/7.jpg"),
      require("../../assets/octavia-pro/imgs/shijia/8.jpg"),
      require("../../assets/octavia-pro/imgs/shijia/9.jpg"),
    ],
    videourl: [
      csvw_url + "/u/cms/www/202105/14234639iM7r.mp4",
      csvw_url + "/u/cms/www/202105/1423440140Fb.mp4",
      csvw_url + "/u/cms/www/202105/142345181KS7.mp4",
      csvw_url + "/u/cms/www/202105/14234609WiYe.mp4",
      csvw_url + "/u/cms/www/202105/14234400o934.mp4",
      csvw_url + "/u/cms/www/202105/14234528Y264.mp4",
      csvw_url + "/u/cms/www/202105/14234643k5ga.mp4",
      csvw_url + "/u/cms/www/202105/142343584V91.mp4",
      csvw_url + "/u/cms/www/202105/14234442q5j4.mp4"
    ],
  },
  // 现场直击(作废板块)
  workspace6: {
    // 移动端
    shipin: [
      require("../../assets/id/imgs/xianchang/1.jpg"),
      require("../../assets/id/imgs/xianchang/2.jpg"),
      require("../../assets/id/imgs/xianchang/3.jpg"),
      require("../../assets/id/imgs/xianchang/4.jpg"),
      require("../../assets/id/imgs/xianchang/5.jpg"),
      require("../../assets/id/imgs/xianchang/6.jpg"),
      require("../../assets/id/imgs/xianchang/7.jpg"),
      require("../../assets/id/imgs/xianchang/8.jpg"),
      require("../../assets/id/imgs/xianchang/9.jpg"),
      require("../../assets/id/imgs/xianchang/10.jpg"),
      require("../../assets/id/imgs/xianchang/11.jpg"),
      require("../../assets/id/imgs/xianchang/12.jpg"),
      require("../../assets/id/imgs/xianchang/13.jpg"),
      require("../../assets/id/imgs/xianchang/14.jpg"),
      require("../../assets/id/imgs/xianchang/15.jpg"),
      require("../../assets/id/imgs/xianchang/16.jpg"),
      require("../../assets/id/imgs/xianchang/17.jpg"),
      require("../../assets/id/imgs/xianchang/18.jpg"),
      require("../../assets/id/imgs/xianchang/19.jpg"),
      require("../../assets/id/imgs/xianchang/20.jpg"),
      require("../../assets/id/imgs/xianchang/21.jpg"),
    ],
    // PC端
    shipinPC: [
      [
        require("../../assets/id/imgs/xianchang/1.jpg"),
        require("../../assets/id/imgs/xianchang/2.jpg"),
        require("../../assets/id/imgs/xianchang/3.jpg"),
      ],
      [
        require("../../assets/id/imgs/xianchang/4.jpg"),
        require("../../assets/id/imgs/xianchang/5.jpg"),
        require("../../assets/id/imgs/xianchang/6.jpg"),
      ],
      [
        require("../../assets/id/imgs/xianchang/7.jpg"),
        require("../../assets/id/imgs/xianchang/8.jpg"),
        require("../../assets/id/imgs/xianchang/9.jpg"),
      ],
      [
        require("../../assets/id/imgs/xianchang/10.jpg"),
        require("../../assets/id/imgs/xianchang/11.jpg"),
        require("../../assets/id/imgs/xianchang/12.jpg"),
      ],
      [
        require("../../assets/id/imgs/xianchang/13.jpg"),
        require("../../assets/id/imgs/xianchang/14.jpg"),
        require("../../assets/id/imgs/xianchang/15.jpg"),
      ],
      [
        require("../../assets/id/imgs/xianchang/16.jpg"),
        require("../../assets/id/imgs/xianchang/17.jpg"),
        require("../../assets/id/imgs/xianchang/18.jpg"),
      ],
      [
        require("../../assets/id/imgs/xianchang/19.jpg"),
        require("../../assets/id/imgs/xianchang/20.jpg"),
        require("../../assets/id/imgs/xianchang/21.jpg"),
      ]
    ],
    // 封面
    fengurl: [
      require("../../assets/id/imgs/xianchang/1-1.jpg"),
      require("../../assets/id/imgs/xianchang/2-1.jpg"),
      require("../../assets/id/imgs/xianchang/3-1.jpg"),
      require("../../assets/id/imgs/xianchang/4-1.jpg"),
      require("../../assets/id/imgs/xianchang/5-1.jpg"),
      require("../../assets/id/imgs/xianchang/6-1.jpg"),
      require("../../assets/id/imgs/xianchang/7-1.jpg"),
      require("../../assets/id/imgs/xianchang/8-1.jpg"),
      require("../../assets/id/imgs/xianchang/9-1.jpg"),
      require("../../assets/id/imgs/xianchang/10-1.jpg"),
      require("../../assets/id/imgs/xianchang/11-1.jpg"),
      require("../../assets/id/imgs/xianchang/12-1.jpg"),
      require("../../assets/id/imgs/xianchang/13-1.jpg"),
      require("../../assets/id/imgs/xianchang/14-1.jpg"),
      require("../../assets/id/imgs/xianchang/15-1.jpg"),
      require("../../assets/id/imgs/xianchang/16-1.jpg"),
      require("../../assets/id/imgs/xianchang/17-1.jpg"),
      require("../../assets/id/imgs/xianchang/18-1.jpg"),
      require("../../assets/id/imgs/xianchang/19-1.jpg"),
      require("../../assets/id/imgs/xianchang/20-1.jpg"),
      require("../../assets/id/imgs/xianchang/21-1.jpg"),
    ]
  }
}
